import { useLoading } from '../../../state-management/contexts/LoadingContext'
import ThreeLineLoading from './ThreeLineLoading'

export const OverlayLoadingPage = () => {
  const { isLoading } = useLoading()

  if (!isLoading) {
    return null
  }

  return <ThreeLineLoading />
}
